{
  "common": {
    "appName": "Aimly Admin",
    "loading": "Yuklanmoqda…",
    "retry": "Qayta urinish",
    "cancel": "Bekor qilish",
    "confirm": "Tasdiqlash",
    "prev": "Oldingi",
    "next": "Keyingi",
    "page": "{{page}} / {{total}}",
    "total": "Jami: {{count}}",
    "all": "Hammasi",
    "yes": "Ha",
    "no": "Yo'q",
    "back": "Orqaga",
    "logout": "Chiqish",
    "language": "Til",
    "theme": "Mavzu",
    "loadError": "Ma'lumotni yuklab bo'lmadi."
  },
  "nav": {
    "users": "Foydalanuvchilar",
    "deliveries": "Yetkazishlar",
    "announcements": "E'lonlar",
    "sectionManage": "Boshqaruv",
    "menu": "Menyu",
    "dashboard": "Dashboard"
  },
  "auth": {
    "title": "Admin panelga kirish",
    "subtitle": "Kirish Telegram orqali. Faqat ruxsat berilgan adminlar kira oladi.",
    "botButton": "Telegram bot orqali kirish",
    "waiting": "Botda «Start» ni bosing va kirishni tasdiqlang. Bu sahifa o'zi yangilanadi.",
    "openAgain": "Botni qayta ochish",
    "expired": "Kirish havolasining muddati o'tdi. Qaytadan boshlang.",
    "devTitle": "Sinov kirishi (faqat dev)",
    "devPlaceholder": "Telegram id",
    "devButton": "Kirish",
    "notConfigured": "Telegram orqali kirish hozircha sozlanmagan.",
    "checking": "Sessiya tekshirilmoqda…",
    "forbiddenTitle": "Ruxsat yo'q",
    "forbiddenText": "Bu Telegram hisobi adminlar ro'yxatida yo'q. Backend'dagi ADMIN_TELEGRAM_IDS ga Telegram id ingizni qo'shing.",
    "yourId": "Sizning Telegram id: {{id}}",
    "otherAccount": "Boshqa hisob bilan kirish"
  },
  "overview": {
    "delivered": "Yetkazildi",
    "failed": "Xato",
    "pending": "Navbatda",
    "successRate": "Muvaffaqiyat: {{percent}}%",
    "noDeliveries": "Bu kanalda hali yuborish bo'lmagan.",
    "failedLink": "Xatolarni ko'rish"
  },
  "users": {
    "title": "Foydalanuvchilar",
    "subtitle": "Qidirish, holatini ko'rish va bloklash",
    "name": "Foydalanuvchi",
    "tasks": "Vazifalar",
    "goals": "Maqsadlar",
    "telegram": "Telegram",
    "lastLogin": "Oxirgi kirish",
    "joined": "Qo'shilgan",
    "status": "Holat",
    "active": "Faol",
    "blocked": "Bloklangan",
    "admin": "Admin",
    "reachable": "Yozsa bo'ladi",
    "unreachable": "Botni bloklagan",
    "emptyTitle": "Foydalanuvchi topilmadi",
    "emptyText": "Qidiruv so'zini qisqartiring yoki filtrni «Hammasi» ga qaytaring.",
    "emptyNoUsers": "Hali hech kim ro'yxatdan o'tmagan. Birinchi foydalanuvchi botda /start bosganda shu yerda ko'rinadi.",
    "open": "{{name}} sahifasini ochish",
    "language": "Til",
    "lastActive": "Oxirgi faollik",
    "activityActive": "Aktiv (7 kun)",
    "activityInactive": "Aktiv emas",
    "activeToday": "bugun",
    "daysAgo": "{{count}} kun oldin",
    "neverActive": "hech qachon"
  },
  "user": {
    "notFound": "Foydalanuvchi topilmadi.",
    "profile": "Profil",
    "activity": "Faollik",
    "schedule": "Eslatmalar vaqti",
    "language": "Til",
    "timezone": "Vaqt zonasi",
    "morning": "Ertalabki reja",
    "planning": "Ertangi rejalash",
    "review": "Kun sarhisobi",
    "tasks": "Vazifalar",
    "completed": "Bajarilgan",
    "completed7d": "Bajarilgan (7 kun)",
    "goals": "Maqsadlar",
    "dailyReviews": "Kunlik sarhisoblar",
    "weeklyReviews": "Haftalik sarhisoblar",
    "failedDeliveries": "Telegram xatolari",
    "telegramId": "Telegram id",
    "block": "Bloklash",
    "unblock": "Blokdan chiqarish",
    "blockTitle": "Foydalanuvchini bloklaysizmi?",
    "blockText": "{{name}} barcha qurilmalardan chiqariladi, kira olmaydi va unga bildirishnoma yuborilmaydi. Ma'lumotlari o'chirilmaydi.",
    "unblockTitle": "Blokdan chiqarasizmi?",
    "unblockText": "{{name}} yana kira oladi va bildirishnomalar tiklanadi.",
    "blocked": "Foydalanuvchi bloklandi.",
    "unblocked": "Foydalanuvchi blokdan chiqarildi.",
    "adminNote": "Admin hisobini bloklab bo'lmaydi.",
    "sendMessage": "Xabar yuborish",
    "notFoundText": "Havola eskirgan yoki hisob o'chirilgan. Ro'yxatdan qidirib ko'ring.",
    "completed7dHint": "Shu haftada: {{count}}",
    "sections": "Foydalanuvchi bo'limlari",
    "tabs": {
      "stats": "Statistika",
      "activity": "Harakatlar",
      "profile": "Profil"
    }
  },
  "deliveries": {
    "title": "Yetkazishlar",
    "subtitle": "Web va Telegram bildirishnomalari holati",
    "status": "Holat",
    "channel": "Kanal",
    "type": "Tur",
    "recipient": "Kimga",
    "attempts": "Urinish",
    "created": "Yaratilgan",
    "sentAt": "Yuborilgan",
    "error": "Xato",
    "retry": "Qayta yuborish",
    "retried": "Qayta yuborildi: {{status}}",
    "emptyTitle": "Yetkazish topilmadi",
    "emptyText": "Tanlangan filtr bo'yicha yozuv yo'q. Filtrni «Hammasi» ga qaytaring.",
    "statuses": {
      "PENDING": "Navbatda",
      "SENT": "Yuborildi",
      "FAILED": "Xato",
      "READ": "O'qildi",
      "SKIPPED": "O'tkazildi"
    },
    "channels": {
      "WEB": "Web",
      "TELEGRAM": "Telegram"
    },
    "types": {
      "DAILY_PLAN": "Kunlik reja",
      "PLANNING_REMINDER": "Rejalash eslatmasi",
      "TASK_REMINDER": "Vazifa eslatmasi",
      "TASK_OVERDUE": "Muddati o'tgan vazifa",
      "TASK_POSTPONED": "Qoldirilgan vazifa",
      "DAILY_REVIEW": "Kun sarhisobi",
      "WEEKLY_REVIEW": "Hafta sarhisobi",
      "SYSTEM": "E'lon"
    }
  },
  "announcements": {
    "title": "E'lonlar",
    "subtitle": "Foydalanuvchilarga Web va Telegram orqali xabar",
    "new": "Yangi e'lon",
    "formTitle": "Sarlavha",
    "formBody": "Matn",
    "target": "Kimga",
    "targetAll": "Barcha faol foydalanuvchilarga",
    "targetOne": "Bitta foydalanuvchiga",
    "targetId": "Telegram id",
    "send": "Yuborish",
    "confirmTitle": "E'lonni yuborasizmi?",
    "confirmAll": "Xabar barcha faol foydalanuvchilarga yuboriladi. Uni qaytarib bo'lmaydi.",
    "confirmOne": "Xabar Telegram id {{id}} egasiga yuboriladi.",
    "sent": "E'lon {{count}} kishiga yuborildi.",
    "history": "Yuborilganlar",
    "toAll": "Hammaga",
    "toOne": "Bitta foydalanuvchiga",
    "emptyTitle": "Hali e'lon yuborilmagan",
    "emptyText": "Yangi imkoniyat yoki texnik ish haqida xabar berish uchun chapdagi formadan foydalaning.",
    "hint": "Telegram'da e'lon «📣 sarlavha» ko'rinishida keladi; bildirishnomalarni o'chirgan foydalanuvchilarga faqat Web'da ko'rinadi.",
    "validation": {
      "title": "Sarlavha 1–200 belgi bo'lishi kerak.",
      "body": "Matn 1–2000 belgi bo'lishi kerak.",
      "telegramId": "Telegram id faqat raqamlardan iborat."
    },
    "preview": "Telegram'da shunday ko'rinadi",
    "recipientsColumn": "Qabul qiluvchi",
    "sentAt": "Yuborilgan"
  },
  "notFound": {
    "title": "Sahifa topilmadi",
    "action": "Bosh sahifaga",
    "text": "Manzil noto'g'ri yoki sahifa ko'chirilgan. Menyudan kerakli bo'limni tanlang."
  },
  "errors": {
    "UNKNOWN_ERROR": "Nimadir noto'g'ri ketdi. Qayta urinib ko'ring.",
    "NETWORK_ERROR": "Server bilan aloqa yo'q. Internetni tekshiring.",
    "INTERNAL_ERROR": "Serverda xatolik. Birozdan keyin qayta urinib ko'ring.",
    "VALIDATION_FAILED": "Ma'lumot noto'g'ri to'ldirilgan.",
    "NOT_FOUND": "Topilmadi.",
    "FORBIDDEN": "Ruxsat yo'q.",
    "RATE_LIMITED": "Juda ko'p urinish. Bir daqiqadan keyin qayta urinib ko'ring.",
    "NO_TOKEN": "Kirish talab qilinadi.",
    "TOKEN_EXPIRED": "Sessiya muddati tugadi.",
    "TOKEN_INVALID": "Sessiya yaroqsiz. Qayta kiring.",
    "TOKEN_STALE": "Sessiya yopilgan. Qayta kiring.",
    "AUTH_FAILED": "Kirib bo'lmadi. Qayta urinib ko'ring.",
    "ACCOUNT_BLOCKED": "Hisob bloklangan.",
    "REFRESH_TOKEN_INVALID": "Sessiya tugadi. Qayta kiring.",
    "REFRESH_TOKEN_REUSED": "Xavfsizlik uchun sessiya yopildi. Qayta kiring.",
    "TELEGRAM_NOT_CONFIGURED": "Telegram orqali kirish hozircha sozlanmagan.",
    "LOGIN_REQUEST_NOT_FOUND": "Kirish so'rovi topilmadi yoki ishlatilgan. Qaytadan boshlang.",
    "LOGIN_REQUEST_EXPIRED": "Kirish havolasining muddati o'tdi. Qaytadan boshlang.",
    "DEV_LOGIN_DISABLED": "Sinov kirishi o'chirilgan.",
    "USER_NOT_FOUND": "Foydalanuvchi topilmadi.",
    "ADMIN_ONLY": "Bu bo'lim faqat adminlar uchun.",
    "CANNOT_BLOCK_ADMIN": "Admin hisobini bloklab bo'lmaydi.",
    "DELIVERY_NOT_FOUND": "Yetkazish topilmadi.",
    "DELIVERY_NOT_RETRYABLE": "Faqat xato bilan tugagan yetkazishni qayta yuborish mumkin."
  },
  "table": {
    "search": "Qidirish…",
    "clear": "Tozalash",
    "clearAll": "Hammasini tozalash",
    "filterBy": "{{column}} bo'yicha filtr",
    "removeFilter": "{{column}} filtrini olib tashlash",
    "sortBy": "{{column}} bo'yicha saralash",
    "sortedAsc": "{{column}}: o'sish tartibida",
    "sortedDesc": "{{column}}: kamayish tartibida",
    "columns": "Ustunlar",
    "columnsHint": "Ko'rinadigan ustunlar",
    "showAll": "Hammasini ko'rsatish",
    "hiddenCount": "{{count}} ta ustun yashirin",
    "rowsPerPage": "Sahifada",
    "range": "{{from}}–{{to}}",
    "of": "/ {{total}}",
    "pages": "Sahifalar",
    "goToPage": "{{page}}-sahifa"
  },
  "dashboard": {
    "title": "Dashboard",
    "subtitle": "Aimly qanday ishlayapti — bir qarashda.",
    "greeting": "Xush kelibsiz, {{name}}! Tanlangan davr bo'yicha barcha ko'rsatkichlar shu yerda.",
    "presets": {
      "today": "Bugun",
      "7d": "7 kun",
      "30d": "30 kun",
      "90d": "90 kun",
      "year": "Yil"
    },
    "filters": {
      "period": "Davr",
      "from": "Boshlanish sanasi",
      "to": "Tugash sanasi",
      "language": "Foydalanuvchilar tili",
      "allLanguages": "Barcha tillar",
      "channel": "Kanal",
      "allChannels": "Barcha kanallar",
      "activeWindow": "Aktiv deb hisoblash oynasi",
      "activeDays": "Aktiv: {{count}} kun",
      "reset": "Filtrlarni tozalash"
    },
    "deltaNew": "yangi",
    "deltaPoints": "{{value}} p.",
    "deltaHint": "Oldingi teng davrda: {{value}}",
    "hoursMinutes": "{{hours}} s {{minutes}} daq",
    "weekdays": "Du,Se,Ch,Pa,Ju,Sh,Ya",
    "activity": {
      "title": "Foydalanuvchilar faolligi",
      "subtitle": "Aktiv — oxirgi {{count}} kunda kirgan yoki biror amal qilgan",
      "active": "Aktiv",
      "inactive": "Aktiv emas",
      "activeShare": "aktiv",
      "dau": "Kunlik",
      "wau": "Haftalik",
      "mau": "Oylik",
      "stickiness": "Qaytish",
      "stickinessHint": "Kunlik / oylik aktivlar: odamlar ilovaga qanchalik tez-tez qaytadi"
    },
    "users": {
      "total": "Jami foydalanuvchi",
      "new": "Yangi",
      "atRisk": "Ketish xavfi",
      "atRiskHint": "Avvalgi {{count}} kunda aktiv edi, hozir emas",
      "never": "Faollashmagan",
      "neverHint": "Birorta ham vazifa yaratmagan",
      "reachable": "Bot yoza oladi",
      "blocked": "Bloklangan"
    },
    "series": {
      "title": "Dinamika",
      "activeUsers": "Aktivlar",
      "signups": "Ro'yxatdan o'tish",
      "tasksCreated": "Yaratilgan vazifa",
      "tasksCompleted": "Bajarilgan vazifa",
      "inPeriod": "tanlangan davrda",
      "bucket": {
        "day": "Kunlar kesimida",
        "week": "Haftalar kesimida",
        "month": "Oylar kesimida"
      }
    },
    "tasks": {
      "created": "Yaratilgan",
      "completed": "Bajarilgan",
      "rate": "Bajarilish",
      "rateHint": "Rejada: {{count}}",
      "postponed": "Qoldirilgan",
      "cancelled": "Bekor qilingan",
      "focus": "Fokus vaqti",
      "focusHint": "Bajarilganlarning haqiqiy vaqti"
    },
    "clock": {
      "title": "Qachon ishlashadi",
      "hours": "Soatlar bo'yicha bajarilish",
      "weekdays": "Hafta kunlari bo'yicha",
      "peak": "Eng faol soat — {{hour}}:00",
      "empty": "Bu davrda bajarilgan vazifa yo'q."
    },
    "funnel": {
      "title": "Faollashuv voronkasi",
      "subtitle": "Davrda ro'yxatdan o'tganlar qay darajagacha yetdi",
      "registered": "Ro'yxatdan o'tdi",
      "createdTask": "Vazifa yaratdi",
      "completedTask": "Vazifa bajardi",
      "wroteReview": "Sharh yozdi",
      "empty": "Bu davrda yangi foydalanuvchi yo'q — davrni kengaytiring."
    },
    "top": {
      "title": "Eng faollar",
      "subtitle": "Bajarilgan / rejadagi vazifalar",
      "empty": "Bu davrda hech kim vazifa bajarmagan."
    },
    "goals": {
      "title": "Maqsad va sharhlar",
      "created": "Yangi maqsad",
      "completed": "Erishilgan",
      "active": "Faol maqsad"
    },
    "reviews": {
      "daily": "Kunlik sharh",
      "weekly": "Haftalik sharh",
      "period": "Oylik/yillik"
    },
    "languages": {
      "title": "Tillar",
      "subtitle": "Barcha foydalanuvchilar"
    },
    "deliveries": "Bildirishnomalar yetkazilishi",
    "hoursOnly": "{{hours}} soat"
  },
  "userStats": {
    "period": "Davr",
    "periods": {
      "day": "Kun",
      "week": "Hafta",
      "month": "Oy",
      "year": "Yil"
    },
    "prev": "Oldingi davr",
    "next": "Keyingi davr",
    "today": "Bugun",
    "planned": "Rejada",
    "completed": "Bajarilgan",
    "rate": "Bajarilish",
    "focus": "Fokus vaqti",
    "postponed": "Qoldirilgan",
    "cancelled": "Bekor qilingan",
    "activeDays": "Faol kunlar",
    "logins": "Kirishlar",
    "chart": "Reja va bajarilish",
    "chartHours": "Soatlar bo'yicha",
    "legend": "Och ustun — rejada, to'q — bajarilgan",
    "legendHours": "Och ustun — yaratilgan, to'q — bajarilgan",
    "priority": "Muhimlik bo'yicha",
    "priorities": {
      "HIGH": "Yuqori",
      "MEDIUM": "O'rta",
      "LOW": "Past"
    },
    "goalsCreated": "Maqsad",
    "goalsCompleted": "Erishilgan",
    "reviews": "Sharh",
    "calendar": "Faollik kalendari",
    "calendarHint": "Oxirgi yil; kunni bosing — o'sha kun statistikasi ochiladi",
    "calendarSummary": "{{days}} faol kun, {{total}} ta amal",
    "calendarCell": "{{date}}: {{count}} ta amal",
    "less": "Kam",
    "more": "Ko'p"
  },
  "activity": {
    "at": "Vaqt",
    "event": "Harakat",
    "object": "Nima",
    "detail": "Tafsilot",
    "forDate": "sana: {{date}}",
    "unknownDevice": "Noma'lum qurilma",
    "emptyTitle": "Harakat topilmadi",
    "emptyText": "Foydalanuvchi hali hech narsa qilmagan: birinchi kirish yoki vazifa shu yerda ko'rinadi.",
    "emptyFiltered": "Bu turdagi harakat yo'q — filtrni olib tashlang.",
    "groups": {
      "session": "Kirishlar",
      "task": "Vazifalar",
      "goal": "Maqsadlar",
      "review": "Sharhlar",
      "notification": "Bildirishnomalar"
    },
    "types": {
      "LOGIN": "Kirdi",
      "TASK_CREATED": "Vazifa yaratdi",
      "TASK_COMPLETED": "Vazifani bajardi",
      "TASK_POSTPONED": "Vazifani ko'chirdi",
      "TASK_CANCELLED": "Vazifani bekor qildi",
      "GOAL_CREATED": "Maqsad qo'ydi",
      "GOAL_COMPLETED": "Maqsadga erishdi",
      "GOAL_ARCHIVED": "Maqsadni arxivladi",
      "DAILY_REVIEW": "Kunlik sharh yozdi",
      "WEEKLY_REVIEW": "Haftalik sharh yozdi",
      "PERIOD_REVIEW": "Davr sharhini yozdi",
      "NOTIFICATION_READ": "Bildirishnomani o'qidi"
    },
    "goalTypes": {
      "YEAR": "yillik maqsad",
      "QUARTER": "choraklik maqsad",
      "MONTH": "oylik maqsad",
      "WEEK": "haftalik maqsad"
    },
    "periods": {
      "MONTH": "Oylik sharh",
      "YEAR": "Yillik sharh"
    }
  }
}
